import React, {useEffect, useState} from 'react'
import { useSelector } from 'react-redux'
import { State } from '../../../../reducers'
import { Pagination } from '../../../../components/Pagination'
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import DeleteIcon from '../../../../media/felsv/MinusDelete.svg'

const docsAsociados = [
  {valor: 'Emisor', codigo: '1'},
  {valor: 'Receptor', codigo: '2'},
] 

const TablaDocsAsociados = (props: any) => {
  const {dataDocsAsociados} = useSelector((state: State) => state.documentos.otrosDocumentosAsociados)
  const [tableDocs, setTableDocs] = useState<any>(dataDocsAsociados || [])

  useEffect(() => {
    setTableDocs(dataDocsAsociados)
  }, [dataDocsAsociados])

  return (
      <>
        <table className='table-main-responsive responsive-table-main td-left'>
          <thead>
            <tr>
              <td>Nombre de sucursal</td>
              <td>Dirección</td>
              <td>Descripción</td>
              <td>Acciones</td>
            </tr>
          </thead>
          <tbody>
            {tableDocs.map((doc:any) => (
              <tr key={doc.id}>
                <td data-label='Código de documento'>{`${doc.tipo} - ${docsAsociados.find((tipo) => tipo.codigo === doc.tipo)?.valor}`}</td>
                <td data-label='Identificación' style={{wordBreak: "break-all"}}>{doc.identificacion}</td>
                <td data-label='Detalle del documento' style={{wordBreak: "break-all"}}>{doc.descripcion}</td>
                {
                  !props.sinAcciones && (
                    <td data-label='Acciones'>
                      <button onClick={() => props.openModalEditar(doc)}><img alt='Edit' src={EditIcon} /></button>
                      <button onClick={() => props.openModalEliminar(doc)}><img alt='Delete' src={DeleteIcon} /></button>
                    </td>
                  )
                }
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination data={dataDocsAsociados || []} state={(items: Array<any>) => setTableDocs(items)} items={5}/>
      </>
  )
}

export default TablaDocsAsociados
